
const localeEnums = {
    ROOM: "Комната",
    BASEMENT: "Подвал",
    UNDERGROUND_PARKING: "Подземный паркинг",
    COMMERCIAL_FLOOR: "Первый коммерческий этаж",
    RESIDENTIAL: "Жилой этаж",
    ATTIC: "Чердак",
    BEDROOM: "Спальня",
    KITCHEN: "Кухня",
    STUDIO: "Студия",
    LIVING_ROOM: "Гостиная",
    HALL: "Прихожая",
    CORRIDOR: "Коридор",
    BATHROOM: "Ванная комната",
    TOILET: "Туалет",
    JOINT_BATHROOM: "Совмещенный санузел",
    LADDER: "Лестница",
    SECURITY: "Помещение охраны",
    PARKING: "Парковка",
    STORAGE: "Помещение для хранения",
    COMMERCIAL: "Коммерческое помещение",
    BALCONY: "Балкон",
    ELEVATOR: "Лифтовая шахта",
    ODS: "Объединенная диспетчерская служба",
    INFORMATION_CENTER: "Информационный центр",
    VENTILATION: "Вентиляционная шахта",
    IHP: "Помещение ИТП",
    ELECTRICAL: "Помещение электрощитовых",
    LOW_VOLTAGE: "Помещение для слаботочных систем",
    PLUMBING: "Помещение насосной хозяйственного и противопожарного водопровода",
    AFES: "Помещение автоматической установки пожаротушения",
    COMMUNICATIONS_CENTER: "Узловое помещение связи",
    WATER_METERING: "Водомерный узел",
    PARKING_VENT: "Шахта дымоудаления из паркинга",
    HEATING_METER: "Узел поквартирного учета отопления",
    ROOM_OBJECT: "Объект комнаты",
    ELECTRICAL_BOX: "Слаботочный шкаф встроенного исполнения",
}

export function localize(name) {
    if (!isNaN(name)) {
        return name
    }
    console.log(name)
    return localeEnums[name.toUpperCase()] || name
}
